import { render, staticRenderFns } from "./GridColumns.vue?vue&type=template&id=10c0f08a&"
import script from "./GridColumns.vue?vue&type=script&lang=js&"
export * from "./GridColumns.vue?vue&type=script&lang=js&"
import style0 from "./GridColumns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports